import { createContext, useContext } from "react";

export type MapMode = "zenrin" | "geospace" | null;

/**
 * 地図コントロール用のContext
 * PropertySelectionGridからLeafletMapの操作を可能にする
 */
export interface MapControlContextType {
  /**
   * アクティブなポップアップを閉じる
   */
  closeActivePopup: () => void;

  /**
   * クリックされた座標をクリアして、同じピンを再度クリック可能にする
   */
  clearClickedLatLng: () => void;

  /**
   * 現在の地図モード（ゼンリン／GEOSPACE／なし）
   */
  mapMode: MapMode;
}

export const MapControlContext = createContext<MapControlContextType | null>(
  null
);

/**
 * MapControlContextを使用するためのカスタムフック
 * @throws Providerの外で使用された場合はエラーを投げる
 */
export const useMapControl = (): MapControlContextType => {
  const context = useContext(MapControlContext);

  if (!context) {
    throw new Error(
      "useMapControl must be used within a MapControlContext.Provider"
    );
  }

  return context;
};
